import React from 'react';

import Image from 'react-bootstrap/Image';

import loaderImg from '../images/loading-icon.png';
import '../styles/Loader.css';

// Standalone spinner (rotating ring + counter-rotating logo). Used as the
// visual for the full-screen <Loader /> and inline placeholders (e.g. the
// Privacy Policy modal while its iframe boots).
const Spinner = () => (
	<div className="loader text-center">
		<Image src={loaderImg} />
	</div>
);

export default Spinner;
